<template lang="pug">
  div.wrap-module-home
    div.home-content.py20
      div(v-for="slide in slides").mb22
        ItemHomeSlideCard(:slide="slide")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-module-home {
  width: 100%;
  min-height: 100vh;
  padding-top: $header_height;
  .home-content {
    margin: 0 auto;
    width: $base_width_percent;
    max-width: $base_max_width_px;
  }
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import ItemHomeSlideCard from '@/components/item/ItemHomeSlideCard'

export default {
  components: {
    ItemHomeSlideCard
  },
  props: {
    slides: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  data () {
    return {

    }
  },
  methods: {
    onLoggedIn () {
      
    },
    onFailedAuthentication () {
      this.$router.push('/sign-in')
    }
  }
}
</script>
